// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1tbSa","content":"LoadingAlert_content__2cLLN"};